// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "paper-2QP2A";
var _4 = "contentWrapper-3uM6o";
var _5 = "header-3uvSJ";
var _6 = "footer-3WUk-";
var _7 = "title-3W7aQ";
export { _1 as "__esModule", _2 as "mobile", _3 as "paper", _4 as "contentWrapper", _5 as "header", _6 as "footer", _7 as "title" }
export default { "__esModule": _1, "mobile": _2, "paper": _3, "contentWrapper": _4, "header": _5, "footer": _6, "title": _7 }
